var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconSend = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 30 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M29.585 13.008c0 .47-.296.763-.71.977C28.848 14 .784 25.954.784 25.954a.572.572 0 01-.532-.041.538.538 0 01-.253-.454v-10.84a.55.55 0 01.537-.542L28.312 13 .537 11.925A.55.55 0 010 11.383V.542A.54.54 0 01.253.088.583.583 0 01.785.047l27.783 11.83c.54.2 1.017.562 1.017 1.131z",
  fill: "#ED625D"
})));

export default SvgIconSend;